import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { styles, utils } from 'gipsy-misc'

import { markTaskAsRead } from 'features/notifications/store/actions'

import { media, Icon, DraftEditor, Tooltip, UserPicture } from 'gipsy-ui'

const PADDING = 8

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      markTaskAsRead
    },
    dispatch
  )
})

class InlineComment extends PureComponent {
  static propTypes = {
    comment: PropTypes.object.isRequired,
    taskId: PropTypes.string.isRequired
  }

  onClick = e => {
    const { taskId } = this.props
    e.preventDefault()
    e.stopPropagation()

    this.props.actions.markTaskAsRead(taskId)
  }

  render() {
    const { comment } = this.props
    const timeAgoStr = utils.string.capitalize(utils.datetime.timeAgo(comment.creationTime))

    return (
      <Container>
        <Content>
          <PictureContainer className="picture-container">
            <UserPicture size={30} src={get(comment, 'from.picture')}>
              {(comment.from.displayName || comment.from.email) && (
                <Tooltip text={comment.from.displayName || comment.from.email} vs={40} hs={15} position="top right" />
              )}
            </UserPicture>
            <TimeAgoMobile>{timeAgoStr}</TimeAgoMobile>
          </PictureContainer>
          <Text>
            <DraftEditor
              key={comment.id}
              readOnly={true}
              paramName={comment.id}
              compact={true}
              defaultValue={comment.richText}
              uploads={this.props.uploads}
            />
          </Text>
          <TimeAgoDesktop>{timeAgoStr}</TimeAgoDesktop>
          <CloseIcon className="close" icon="Close" size={28} onClick={this.onClick} />
        </Content>
      </Container>
    )
  }
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  { pure: true }
)(InlineComment)

const Container = styled.div`
  width: 100%;
  padding-left: 60px;
  padding-right: 60px;
  cursor: pointer;
  ${media['phone-wide']`
    padding-left: 20px;
    padding-right: 20px;
  `}
`

const Content = styled.div`
  position: relative;
  width: 100%;
  background-color: white;
  border-radius: 16px;
  padding: ${PADDING}px ${PADDING * 2}px;
  margin-top: 8px;
  display: inline-flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: ${styles.fonts.fontSizeSmall};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  ${media['phone-wide']`
    flex-direction: column;
  `}
  & > * {
    display: inline-block;
    vertical-align: middle;
    line-height: 20px;
    margin-top: 5px;
    flex-shrink: 0;
    &:last-child {
      margin-right: 0;
    }
  }
`

const CloseIcon = styled(Icon)`
  padding: 10px;
  margin-top: 2px;
  ${media['phone-wide']`
    display: none;
  `}
`

const PictureContainer = styled.div`
  display: flex;
  margin-right: ${styles.spacings.small};
  margin-top: 0;
  ${media['phone-wide']`
    flex-direction: row;
    align-items: center;
  `}
`

const Text = styled.div`
  flex-shrink: 1;
  max-height: 80px;
  overflow: hidden;
`

const TimeAgoDesktop = styled.div`
  color: ${styles.colors.textLightColor};
  font-size: ${styles.colors.fontSizeXSmall};
  margin-left: auto;
  margin-right: ${styles.spacings.small};
  ${media['phone-wide']`
    display: none
  `}
`

const TimeAgoMobile = styled.div`
  display: none;
  color: ${styles.colors.textLightColor};
  font-size: ${styles.colors.fontSizeXSmall};
  ${media['phone-wide']`
    display: block;
    margin-left: ${styles.spacings.xsmall};
  `}
`



// WEBPACK FOOTER //
// ./src/features/list/components/inlineComment/index.js